import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { TransactionsDto } from '../models/dto/transactions-dto.model';

@Directive({
  selector: '[boiCategorizeTransactionIcon]'
})
export class CategorizeTransactionIconDirective implements OnInit, OnChanges {
  @Input() public transaction: TransactionsDto;

  private readonly transactionIcons = {
    switch: 'switch',
    nonadvised: 'originator',
    advised: 'originator'
  };

  constructor(private hostElement: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.addCaseStatusCssClass();
  }

  ngOnChanges(): void {
    this.addCaseStatusCssClass();
  }

  private addCaseStatusCssClass(): void {
    let cssClass = !this.transaction.IsCaseTransaction ? 'trans' : '';
    const caseType = this.transaction && this.transaction.CaseType && this.transaction.CaseType.toLocaleLowerCase();

    cssClass = this.transactionIcons[caseType] ? `${cssClass} ${this.transactionIcons[caseType]}` : cssClass;

    this.renderer.addClass(this.hostElement.nativeElement, cssClass.trim());
  }
}
